const GRAPH_MIN_HEIGHT = 350;
export default GRAPH_MIN_HEIGHT;
